import React from "react";
import InputMask from "react-input-mask";
import Cards from "react-credit-cards";
import { TextField, Button, Input, Box } from "@mui/material";
import axios from "axios";
import { useAws } from "../aws";
import { Navigate } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Snackbar from "@mui/material/Snackbar";
import { useDecodedParams } from "../misc/utils";
import MuiAlert from "@mui/material/Alert";
import { DatePicker } from "@mui/x-date-pickers";
import { format, parse } from "date-fns";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default class PaymentForm extends React.Component {
  x_api_key = useAws();
  payment_id = this.props.payment_id;
  type = this.props.type;
  windowSize = this.props.windowSize;
  donationData = this.props.donationData;
  state = {
    openSnack: false,
    openBackdrop: false,
    cvc: "",
    expiry: "",
    focus: "",
    name: "",
    number: "",
    status: "",
    myErrors: {
      cvc: "CVC must be at least 3 characters long!",
      expiry: "Expiration date must contain 4 characters!",
      name: "Name must contain some characters!",
      number: "Number must be at least 16 characters long!",
    },
  };

  handleInputFocus = (e) => {
    console.log(e);
    this.setState({ focus: e.target.name });
  };

  isValidDate = (d) => {
    return d instanceof Date && !isNaN(d);
  };

  handleInputChange = (e) => {
    let { name, value } = e.target;
    let myErrors = this.state.myErrors;
    // this.setState({ [name]: value });

    switch (name) {
      case "number":
        this.state.myErrors.number = value.length < 16 ? "Number must be at least 16 characters long!" : "";
        break;
      case "cvc":
        this.state.myErrors.cvc = value.length < 3 ? "CVC must be at least 3 characters long!" : "";
        break;
      case "name":
        this.state.myErrors.name = /[^a-z\s]/i.test(value) ? "Name must contain only letters!" : "";
        break;
      case "expiry":
        const valueDate = new Date(`${2000 + parseInt(value.slice(3, 5))}/${parseInt(value.slice(0, 2))}/01`);
        if (this.isValidDate(valueDate) && value.length === 5) {
          console.log(value.length, valueDate, 2000 + parseInt(value.slice(3, 5)), new Date().getFullYear());
          this.state.myErrors.expiry = 2000 + parseInt(value.slice(3, 5)) < new Date().getFullYear() ? "Card is expired!" : "";
        } else {
          this.state.myErrors.expiry = "Please enter the correct date format";
        }
        break;
      default:
        break;
    }
    this.setState({ myErrors, [name]: value });
  };

  validateForm = (errors) => {
    let valid = true;
    Object.values(errors).forEach((val) => val.length > 0 && (valid = false));
    return valid;
  };

  handleOpenSnack = () => {
    this.setState({ openSnack: true });
  };

  handleCloseSnack = () => {
    this.setState({ openSnack: false });
  };

  handleCloseBackdrop = () => {
    this.setState({ openBackdrop: false });
  };
  handleToggleBackdrop = () => {
    this.setState({ openBackdrop: true });
  };

  // recurring/one-off summary shown above the card form
  renderRecurringSummary = () => {
    const d = this.donationData;
    if (!d || this.type !== "donation" || !d.frequency) return null;
    const monthly = d.frequency === "monthly";
    const programName = d.programName || "一般用途";
    const amount = Number(d.donationAmount || 0).toLocaleString();
    return (
      <div
        style={{
          width: "100%",
          maxWidth: "480px",
          background: "#eaf4fb",
          border: "1px solid #bfddf1",
          borderRadius: "8px",
          padding: "14px 18px",
          margin: "0 0 20px",
          boxSizing: "border-box",
          textAlign: "left",
        }}
      >
        <h4 style={{ fontWeight: 700, fontSize: "16px" }}>
          {monthly ? (
            <>
              <span
                style={{
                  background: "#1976d2",
                  color: "#fff",
                  borderRadius: "12px",
                  padding: "2px 10px",
                  fontSize: "12px",
                  marginRight: "8px",
                  verticalAlign: "middle",
                }}
              >
                每月定期捐款
              </span>
              {`港幣 $${amount}／月`}
            </>
          ) : (
            `單次捐款 港幣 $${amount}`
          )}
        </h4>
        <p style={{ fontSize: "13px", marginTop: "8px" }}>{`支持計劃：${programName}`}</p>
        {monthly ? (
          <ul style={{ fontSize: "12px", color: "#555", margin: "8px 0 0", paddingLeft: "18px" }}>
            <li>首次捐款於今日扣款，其後每月同日自動扣款。</li>
            <li>{`每次扣款成功後，捐款收據將自動發送至 ${d.confirmEmail || "您的電郵"}。`}</li>
            <li>您可隨時取消每月捐款，無需任何手續費。</li>
          </ul>
        ) : null}
      </div>
    );
  };

  handleSubmit = () => {
    if (this.validateForm(this.state.myErrors)) {
      console.info("Valid Form");
      console.info(this.x_api_key.x_api_key);
      if (this.type == "donation") {
        axios
          .post(
            (process.env.REACT_APP_ENV == "DEV"
              ? "https://4kcdgeqkgf.execute-api.us-east-1.amazonaws.com/dev_pnb_public_api"
              : "https://boo7z0hhbk.execute-api.us-east-1.amazonaws.com/pnb_public_api_stage") + "/user/create_payment_stripe_donation",
            {
              card_number: this.state.number,
              card_exp_month: parseInt(this.state.expiry.slice(0, 2)),
              card_exp_year: 2000 + parseInt(this.state.expiry.slice(3, 5)),
              card_cvc: this.state.cvc,
              d_id: this.payment_id,
            },
            {
              headers: {
                "x-api-key": this.x_api_key.x_api_key,
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            console.log(res.data.body);
            if (res?.data?.statusCode === 200) {
              console.log("SUCCESS");
              this.setState({ status: "success" });
              // navigate(`/result/2430e09`);
            } else {
              console.log("FAIL");
              this.setState({ status: "failed" });
              // navigate(`/event/failed`);
            }
          });
      } else {
        axios
          .post(
            (process.env.REACT_APP_ENV == "DEV"
              ? "https://4kcdgeqkgf.execute-api.us-east-1.amazonaws.com/dev_pnb_public_api"
              : "https://boo7z0hhbk.execute-api.us-east-1.amazonaws.com/pnb_public_api_stage") + "/user/create_payment_stripe_event",
            {
              card_number: this.state.number,
              card_exp_month: parseInt(this.state.expiry.slice(0, 2)),
              card_exp_year: 2000 + parseInt(this.state.expiry.slice(3, 5)),
              card_cvc: this.state.cvc,
              p_id: this.payment_id,
            },
            {
              headers: {
                "x-api-key": this.x_api_key.x_api_key,
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            console.log(res.data.body);
            if (res?.data?.statusCode === 200) {
              console.log("SUCCESS");
              this.setState({ status: "success" });
              // navigate(`/donation/2430e09`);
            } else {
              console.log("FAIL");
              this.setState({ status: "failed" });
              // navigate(`/donation/failed`);
            }
          });
      }
      this.handleToggleBackdrop();
    } else {
      console.error("Invalid Form");
      this.handleOpenSnack();
    }
  };

  showError = () => {
    let error = "";
    error += this.state.myErrors.number + "\n";
    error += this.state.myErrors.name + "\n";
    error += this.state.myErrors.expiry + "\n";
    error += this.state.myErrors.cvc + "\n";
    console.log(error);
    return error;
  };

  render() {
    let { status } = this.state;
    return this.windowSize.current[0] > 600 ? (
      <>
        {this.renderRecurringSummary()}
      <div className="PaymentForm1">
        <div>
          <Cards cvc={this.state.cvc} expiry={this.state.expiry} focused={this.state.focus} name={this.state.name} number={this.state.number} />
        </div>
        <Box
          sx={{
            "& > :not(style)": { m: 1, width: "25ch" },
          }}
          autoComplete="off"
          style={{ marginLeft: 10 }}
        >
          <TextField
            className="paymentform"
            required
            size="small"
            label="Card Number"
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
              //   if (event.target.value.length > 0 && event.target.value.length % 4 == 0)
              //   event.target.value = event.target.value + ' '
              // else
              //   if (event.target.value.length % 5 == 0 && event.target.value.charAt(event.target.value.length - 1) === ' ')
              //     event.target.value = event.target.value.replace(' ', '');
            }}
            inputProps={{ maxLength: "16" }}
            type="tel"
            name="number"
            onChange={this.handleInputChange}
            onFocus={this.handleInputFocus}
            fullWidth={true}
          />
          <TextField
            required
            size="small"
            type="text"
            name="name"
            label="Name"
            onChange={this.handleInputChange}
            onFocus={this.handleInputFocus}
            fullWidth={true}
          />
          <div className="makeRow">
            {/* <TextField
              required
              style={{ width: 160, marginRight: 15 }}
              size="small"
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
                if (event.target.value.length === 2) event.target.value = event.target.value + "/";
                else if (event.target.value.length === 3 && event.target.value.charAt(2) === "/") event.target.value = event.target.value.replace("/", "");
              }}
              inputProps={{ maxLength: "5" }}
              type="tel"
              name="expiry"
              label="Exp. date"
              onChange={this.handleInputChange}
              onFocus={this.handleInputFocus}
            /> */}
            {/* <DatePicker
              variant="outlined"
              label="Exp. date"
              name="expiry"
              onChange={(v) => this.handleInputChange({ target: { name: "expiry", value: v } })}
              renderInput={(params) => <TextField {...params} size="small" sx={{ width: 160, marginRight: "15px" }} onFocus={this.handleInputFocus} />}
              inputFormat="MM/yy"
              disableOpenPicker
            /> */}
            <InputMask mask="99/99" maskChar={null} value={this.state.expiry} onChange={this.handleInputChange}>
              {() => <TextField size="small" sx={{ width: 160, marginRight: "15px" }} name="expiry" label="Exp. date" />}
            </InputMask>
            <TextField
              required
              style={{ width: 150 }}
              size="small"
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              inputProps={{ maxLength: "3" }}
              type="tel"
              name="cvc"
              label="CVC"
              onChange={this.handleInputChange}
              onFocus={this.handleInputFocus}
            />
          </div>
          <Button variant="contained" style={{ width: "92%" }} onClick={this.handleSubmit}>
            {this.donationData?.frequency === "monthly" ? "確認並開始每月捐款" : "PAY"}
          </Button>
        </Box>
        <Snackbar
          open={this.state.openSnack}
          autoHideDuration={6000}
          onClose={this.handleCloseSnack}
          //message= {this.showError()}
          //severity="error"
          // action={action}
        >
          <Alert onClose={this.handleCloseSnack} severity="error" sx={{ width: "100%" }}>
            {this.showError()}
          </Alert>
        </Snackbar>
        <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={this.state.openBackdrop}>
          <CircularProgress color="inherit" />
        </Backdrop>
        {this.state.status == "success" && this.type == "donation" ? (
          <Navigate to="/donation/2430e09" replace={true}></Navigate>
        ) : this.state.status == "failed" && this.type == "donation" ? (
          <Navigate to="/donation/fail" replace={true}></Navigate>
        ) : this.state.status == "success" && this.type == "event" ? (
          <Navigate to="/result/2430e09" replace={true}></Navigate>
        ) : this.state.status == "failed" && this.type == "event" ? (
          <Navigate to="/result/fail" replace={true}></Navigate>
        ) : (
          ""
        )}
      </div>
      </>
    ) : (
      <>
        {this.renderRecurringSummary()}
      <div className="PaymentForm2">
        <div>
          <Cards cvc={this.state.cvc} expiry={this.state.expiry} focused={this.state.focus} name={this.state.name} number={this.state.number} />
        </div>
        <Box
          sx={{
            "& > :not(style)": { m: 1, width: "25ch" },
          }}
          autoComplete="off"
          style={{ marginLeft: 10 }}
        >
          <TextField
            className="paymentform"
            required
            size="small"
            label="Card Number"
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
              //   if (event.target.value.length > 0 && event.target.value.length % 4 == 0)
              //   event.target.value = event.target.value + ' '
              // else
              //   if (event.target.value.length % 5 == 0 && event.target.value.charAt(event.target.value.length - 1) === ' ')
              //     event.target.value = event.target.value.replace(' ', '');
            }}
            inputProps={{ maxLength: "16" }}
            type="tel"
            name="number"
            onChange={this.handleInputChange}
            onFocus={this.handleInputFocus}
            fullWidth={true}
          />
          <TextField
            required
            size="small"
            type="text"
            name="name"
            label="Name"
            onChange={this.handleInputChange}
            onFocus={this.handleInputFocus}
            fullWidth={true}
          />
          <div className="makeRow">
            {/* <TextField
              required
              style={{ width: 160, marginRight: 15 }}
              size="small"
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
                if (event.target.value.length === 2) event.target.value = event.target.value + "/";
                else if (event.target.value.length === 3 && event.target.value.charAt(2) === "/") event.target.value = event.target.value.replace("/", "");
              }}
              inputProps={{ maxLength: "5" }}
              type="tel"
              name="expiry"
              label="Exp. date"
              onChange={this.handleInputChange}
              onFocus={this.handleInputFocus}
            /> */}
            {/* <DatePicker
              variant="outlined"
              label="Exp. date"
              name="expiry"
              onChange={(v) => this.handleInputChange({ target: { name: "expiry", value: v } })}
              renderInput={(params) => <TextField {...params} size="small" sx={{ width: 160, marginRight: "15px" }} onFocus={this.handleInputFocus} />}
              inputFormat="MM/yy"
              disableOpenPicker
            /> */}
            <InputMask mask="99/99" maskChar={null} value={this.state.expiry} onChange={this.handleInputChange}>
              {() => <TextField size="small" sx={{ width: 160, marginRight: "15px" }} name="expiry" label="Exp. date" />}
            </InputMask>
            <TextField
              required
              style={{ width: 150 }}
              size="small"
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              inputProps={{ maxLength: "3" }}
              type="tel"
              name="cvc"
              label="CVC"
              onChange={this.handleInputChange}
              onFocus={this.handleInputFocus}
            />
          </div>
          <Button variant="contained" style={{ width: "92%" }} onClick={this.handleSubmit}>
            {this.donationData?.frequency === "monthly" ? "確認並開始每月捐款" : "PAY"}
          </Button>
        </Box>
        <Snackbar
          open={this.state.openSnack}
          autoHideDuration={6000}
          onClose={this.handleCloseSnack}
          //message= {this.showError()}
          //severity="error"
          // action={action}
        >
          <Alert onClose={this.handleCloseSnack} severity="error" sx={{ width: "100%" }}>
            {this.showError()}
          </Alert>
        </Snackbar>
        <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={this.state.openBackdrop}>
          <CircularProgress color="inherit" />
        </Backdrop>
        {this.state.status == "success" && this.type == "donation" ? (
          <Navigate to="/donation/2430e09" replace={true}></Navigate>
        ) : this.state.status == "failed" && this.type == "donation" ? (
          <Navigate to="/donation/fail" replace={true}></Navigate>
        ) : this.state.status == "success" && this.type == "event" ? (
          <Navigate to="/result/2430e09" replace={true}></Navigate>
        ) : this.state.status == "failed" && this.type == "event" ? (
          <Navigate to="/result/fail" replace={true}></Navigate>
        ) : (
          ""
        )}
      </div>
      </>
    );
  }
}
